import { useGetProperLeverageMargin } from '@ui/features/Trade/hooks/useGetProperLeverageMargin';
import { useLeverage } from '@ui/features/Trade/store/useLeverage';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';

export const useCurrentLeverageMargin = () => {
  const currentTradePairInfo = useTradingPair((s) => s.useTradingPair());
  const leverage = useLeverage();

  return useGetProperLeverageMargin(currentTradePairInfo, leverage);
};
